<main class="content">
  <section class="hero-slider">
    @if (!isFirstHero) {
      <button type="button" class="hero-arrow hero-arrow-left" (click)="prevHero()" aria-label="Vista anterior">
        ‹
      </button>
    }
    @if (!isLastHero) {
      <button type="button" class="hero-arrow hero-arrow-right" (click)="nextHero()" aria-label="Vista siguiente">
        ›
      </button>
    }

    <div class="hero-scene-frame">
      <div class="hero-scene" [style.transform]="heroSceneTransform">
        <img
          src="/images/yango-bg.png"
          alt="Paisaje urbano"
          class="hero-bg-image"
          width="1600"
          height="900"
        />
      </div>

      <div class="hero-copy" [class.hero-copy-right]="activeHero.copyAlign === 'right'">
        <h1 class="hero-title">
          @for (line of activeHero.headline; track $index) {
            <span class="hero-title-line">
              @for (segment of line; track $index) {
                <span [class.hero-title-blue]="segment.color === 'blue'" [class.hero-title-red]="segment.color === 'red'">
                  {{ segment.text }}
                </span>
              }
            </span>
          }
        </h1>

        <p class="hero-subtitle">{{ activeHero.subtitle }}</p>

        <ul class="benefits">
          @for (bullet of activeHero.bullets; track bullet) {
            <li>{{ bullet }}</li>
          }
        </ul>

        @if (activeHero.driverLabel && activeHero.price && activeHero.priceSuffix) {
          <p class="driver-title">{{ activeHero.driverLabel }}</p>
          <p class="price">
            {{ activeHero.price }}<span>{{ activeHero.priceSuffix }}</span>
          </p>
        }

        @if (activeHero.showCta && activeHero.ctaText) {
          <button type="button" class="cta" (click)="openPortabilityModal()">
            {{ activeHero.ctaText }}
          </button>
        }

        <p class="caption">{{ activeHero.caption }}</p>

        @if (activeHero.showPartnerLogos) {
          <div class="hero-logos">
            <img
              src="/images/virgin-yango.png"
              alt="Virgin y Yango"
              class="hero-logo-combo"
              width="132"
              height="22"
            />
          </div>
        }
      </div>
    </div>
  </section>
</main>

<section class="compare-section">
  <div class="compare-shell">
    <h2 class="compare-title">
      <span class="compare-title-primary">TODO LO QUE NECESITAS</span><br />
      <span class="compare-title-secondary">EN UN SOLO PLAN</span>
    </h2>
    <p class="compare-subtitle">
      Compara y elige con la seguridad de llevarte el "extra" que rinde mas, al
      precio mas accesible del mercado.
    </p>

    <div class="compare-card">
      <div class="compare-head compare-row">
        <span>Proveedor</span>
        <span>Plan</span>
        <span>Incluye</span>
      </div>

      <div class="compare-row">
        <div class="provider-cell">
          <img
            class="provider-logo"
            src="/images/virgin.png"
            alt="Virgin Mobile"
            width="88"
            height="24"
          />
        </div>
        <div>
          <p class="plan-main">60GB</p>
          <p class="plan-sub">$23.400</p>
          <p class="plan-note">vigilancia 30 dias</p>
        </div>
        <div class="apps-cell">
          <img class="compare-apps-image" src="/images/apps-1.png" alt="Apps incluidas plan Virgin" width="178" height="20" />
        </div>
      </div>

      <div class="compare-row">
        <div class="provider-cell">
          <span class="dot dot-red"></span>
          <span>Otro</span>
        </div>
        <div>
          <p class="plan-main">60GB</p>
          <p class="plan-sub">$49.900</p>
        </div>
        <div class="apps-cell">
          <img class="compare-apps-image" src="/images/apps-2.png" alt="Apps incluidas operador 2" width="178" height="20" />
        </div>
      </div>

      <div class="compare-row">
        <div class="provider-cell">
          <span class="dot dot-blue"></span>
          <span>Otro</span>
        </div>
        <div>
          <p class="plan-main">60GB</p>
          <p class="plan-sub">$49.900</p>
        </div>
        <div class="apps-cell">
          <span class="apps-text">Suscripcion a IA</span>
        </div>
      </div>

      <div class="compare-row">
        <div class="provider-cell">
          <span class="dot dot-purple"></span>
          <span>Otro</span>
        </div>
        <div>
          <p class="plan-main">60GB</p>
          <p class="plan-sub">$39.900</p>
        </div>
        <div class="apps-cell">
          <img class="compare-apps-image" src="/images/apps-3.png" alt="Apps incluidas operador 3" width="178" height="20" />
        </div>
      </div>

      <div class="compare-row">
        <div class="provider-cell">
          <span class="dot dot-strong-blue"></span>
          <span>Otro</span>
        </div>
        <div>
          <p class="plan-main">60GB</p>
          <p class="plan-sub">$49.900</p>
        </div>
        <div class="apps-cell">
          <img class="compare-apps-image" src="/images/apps-4.png" alt="Apps incluidas operador 4" width="178" height="20" />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="motor-section">
  <div class="motor-shell">
    <h2 class="motor-title">
      <span class="motor-title-red">TU OFICINA MOTORIZADA</span><br />
      <span class="motor-title-blue">Y TU PLAN TAMBIEN.</span>
    </h2>

    <p class="motor-subtitle">
      Obten 10% de descuento en nuestros planes especificos para ti y tu automovil.
    </p>

    <div class="motor-grid">
      <div class="motor-item">
        <p class="motor-old-price">
          Antes: <span class="motor-old-price-strike">$26.000</span>
        </p>
        <article class="motor-card">
        <div class="motor-card-top">
          <p class="motor-driver-copy">Si eres socio conductor Yango</p>
          <p class="motor-price">$23.400</p>
          <p class="motor-validity">Vigencia 30 dias</p>
        </div>
        <div class="motor-card-bottom">
          <div class="motor-inner">
            <p class="motor-gb">60GB</p>
            <div class="motor-features">
              <p class="motor-feature-row">
                <img
                  class="motor-feature-icon"
                  src="/images/waze.png"
                  alt="Icono Waze"
                  width="10"
                  height="10"
                />
                Waze ilimitado
              </p>
              <span class="motor-separator"></span>
              <p class="motor-feature-copy">Comparte datos ilim.</p>
              <span class="motor-separator"></span>
              <p class="motor-feature-title">Redes ilimitadas</p>
              <img
                class="motor-card-img"
                src="/images/apps-1.png"
                alt="Apps incluidas"
                width="132"
                height="12"
              />
              <span class="motor-separator"></span>
              <p class="motor-feature-copy strong">Minutos y SMS ilimitados</p>
              <p class="motor-feature-copy">Todo destino nacional</p>
            </div>
          </div>
          <button type="button" class="motor-btn" (click)="openWhatsApp()">CAMBIATE</button>
          <p class="motor-footnote">*Vigencia en 30 dias calendario</p>
        </div>
        </article>
      </div>

      <div class="motor-item">
        <p class="motor-old-price">
          Antes: <span class="motor-old-price-strike">$33.000</span>
        </p>
        <article class="motor-card">
        <div class="motor-card-top">
          <p class="motor-driver-copy">Si eres socio conductor Yango</p>
          <p class="motor-price">$29.700</p>
          <p class="motor-validity">Vigencia 30 dias</p>
        </div>
        <div class="motor-card-bottom">
          <div class="motor-inner">
            <p class="motor-gb">90GB</p>
            <div class="motor-features">
              <p class="motor-feature-row">
                <img
                  class="motor-feature-icon"
                  src="/images/waze.png"
                  alt="Icono Waze"
                  width="10"
                  height="10"
                />
                Waze ilimitado
              </p>
              <span class="motor-separator"></span>
              <p class="motor-feature-copy">Comparte datos ilim.</p>
              <span class="motor-separator"></span>
              <p class="motor-feature-title">Redes ilimitadas</p>
              <img
                class="motor-card-img"
                src="/images/apps-1.png"
                alt="Apps incluidas"
                width="132"
                height="12"
              />
              <span class="motor-separator"></span>
              <p class="motor-feature-copy strong">Minutos y SMS ilimitados</p>
              <p class="motor-feature-copy">Todo destino nacional</p>
            </div>
          </div>
          <button type="button" class="motor-btn" (click)="openWhatsApp()">CAMBIATE</button>
          <p class="motor-footnote">*Vigencia en 30 dias calendario</p>
        </div>
        </article>
      </div>

      <div class="motor-item">
        <p class="motor-old-price">
          Antes: <span class="motor-old-price-strike">$40.000</span>
        </p>
        <article class="motor-card">
        <div class="motor-card-top">
          <p class="motor-driver-copy">Si eres socio conductor Yango</p>
          <p class="motor-price">$36.000</p>
          <p class="motor-validity">Vigencia 30 dias</p>
        </div>
        <div class="motor-card-bottom">
          <div class="motor-inner">
            <p class="motor-gb">120GB</p>
            <div class="motor-features">
              <p class="motor-feature-row">
                <img
                  class="motor-feature-icon"
                  src="/images/waze.png"
                  alt="Icono Waze"
                  width="10"
                  height="10"
                />
                Waze ilimitado
              </p>
              <span class="motor-separator"></span>
              <p class="motor-feature-copy">Comparte datos ilim.</p>
              <span class="motor-separator"></span>
              <p class="motor-feature-title">Redes ilimitadas</p>
              <img
                class="motor-card-img"
                src="/images/apps-1.png"
                alt="Apps incluidas"
                width="132"
                height="12"
              />
              <span class="motor-separator"></span>
              <p class="motor-feature-copy strong">Minutos y SMS ilimitados</p>
              <p class="motor-feature-copy">Todo destino nacional</p>
            </div>
          </div>
          <button type="button" class="motor-btn" (click)="openWhatsApp()">CAMBIATE</button>
          <p class="motor-footnote">*Vigencia en 30 dias calendario</p>
        </div>
        </article>
      </div>
    </div>
  </div>
</section>

<section class="office-section">
  <div class="office-shell">
    <div class="office-layout">
      <div class="office-copy">
        <h2 class="office-title">
          <span class="office-title-blue">EN VIRGIN MOBILE SABEMOS QUE</span><br />
          <span class="office-title-red">TU AUTO ES TU OFICINA EN MARCHA.</span>
        </h2>

        <p class="office-text">
          Y para arrancar bien cada dia, no basta con gasolina.. necesitas un plan
          que te acompane en cada kilometro.
        </p>
        <p class="office-text office-text-spaced">
          Por eso, si eres socio conductor de Yango:
        </p>

        <ul class="office-benefits">
          <li>
            <img class="office-icon-img" src="/images/info-1.png" alt="Beneficio 1" width="22" height="22" />
            <span>¡Recibe el <strong>10% de descuento</strong> en planes seleccionados!</span>
          </li>
          <li>
            <img class="office-icon-img" src="/images/info-2.png" alt="Beneficio 2" width="22" height="22" />
            <span>
              Linea de atencion exclusiva para socios conductores yango 3195005050
            </span>
          </li>
          <li>
            <img class="office-icon-img" src="/images/info-3.png" alt="Beneficio 3" width="22" height="22" />
            <span><strong>Waze ILIMITADO</strong> para guiarte sin perderte.</span>
          </li>
          <li>
            <img class="office-icon-img" src="/images/info-4.png" alt="Beneficio 4" width="22" height="22" />
            <span>
              <strong>Datos para compartir sin limites</strong>, porque sabemos que
              mas de un dispositivo va contigo al volante.
            </span>
          </li>
        </ul>

        <p class="office-footer">
          Subete a Virgin Mobile y maneja tu oficina con la mejor conexion
        </p>
      </div>

      <div class="office-media">
        <img
          src="/images/yango-landing-3.png"
          alt="Yango beneficios en auto"
          class="office-image"
          width="360"
          height="360"
        />
      </div>
    </div>
  </div>
</section>

<section class="hours-section">
  <div class="hours-shell">
    <h2 class="hours-title">
      <span class="hours-title-blue">SI TE MUEVES SOBRE RUEDAS,</span><br />
      <span class="hours-title-red">CONÉCTATE CON MÁS DATOS.</span>
    </h2>

    <p class="hours-subtitle">
      ¿Sabes cuántos datos gastas por hora? Aquí lo contamos; recuerda que con
      Virgin Mobile tienes un socio en el camino.
    </p>

    <div class="hours-bar-wrap">
      <img
        src="/images/yango-landing-4.png"
        alt="Horas conectado y datos necesarios"
        class="hours-bar-image"
        width="540"
        height="104"
      />
    </div>

    <div class="hours-metrics">
      <div>
        <p class="hours-label">Horas conectado</p>
        <p class="hours-value">8 horas</p>
      </div>
      <div class="hours-metric-right">
        <p class="hours-label">Datos necesarios</p>
        <p class="hours-value">90GB</p>
      </div>
    </div>
  </div>
</section>

<section class="promo-section">
  <div class="promo-shell">
    <div class="promo-card">
      <img
        src="/images/yango-landing-5.png"
        alt="Conductor Yango con Virgin Mobile"
        class="promo-image"
        width="260"
        height="300"
      />

      <div class="promo-content">
        <h2 class="promo-title">
          ARRANCA CON<br />
          VIRGIN MOBILE SIN DESVIOS
        </h2>
        <p class="promo-text">
          Haz el cambio de operador sin frenar tu trayecto, desde tu celular o en
          nuestros puntos fisicos.
        </p>
        <button type="button" class="promo-btn" (click)="openWhatsApp()">
          CAMBIATE AQUI
        </button>
        <p class="promo-terms">
          Aplican terminos y condiciones en
          <span>www.virginmobile.co/legal/terminos-condiciones/</span>
        </p>
      </div>
    </div>
  </div>
</section>

@if (isPortabilityModalOpen) {
  <div class="modal-overlay" (click)="closePortabilityModal()">
    <section
      class="portability-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="portability-modal-title"
      (click)="$event.stopPropagation()"
    >
      <button
        type="button"
        class="modal-close"
        aria-label="Cerrar modal"
        (click)="closePortabilityModal()"
      >
        X
      </button>

      <h2 id="portability-modal-title" class="modal-title">
        COMO DESEAS HACER TU PORTABILIDAD?
      </h2>

      <p class="modal-description">
        En Virgin Mobile te ayudamos a hacer tu portabilidad por medio de WhatsApp
        o, si deseas, puedes realizarla tu mismo desde nuestro sitio web.
      </p>

      <p class="modal-question">Por cual medio deseas hacer tu portabilidad?</p>

      <div class="modal-actions">
        <a
          class="modal-btn modal-btn-outline"
          href="https://wa.me/573337909090"
          target="_blank"
          rel="noopener noreferrer"
        >
          VIA WHATSAPP
        </a>

        <a
          class="modal-btn modal-btn-primary"
          href="https://virginmobile.co"
          target="_blank"
          rel="noopener noreferrer"
        >
          SITIO WEB VIRGIN MOBILE
        </a>
      </div>
    </section>
  </div>
}
